import * as React from 'react';

import type { SimplePagination } from '@klareospace/pharos-lib-web-utils';
import { Card, CardContent } from '@klareospace/pharos-lib-web-utils';
import { useTranslation } from 'react-i18next';
import { TEMPLATE_TYPE } from '@klareospace/pharos-lib-types';

import { CatalogModal } from '../../catalog';
import { InstallShipperDrawer, ShippersActionBar, ShippersTable } from '../components';
import { useShippersPage } from '../hooks';

// ─── Page ─────────────────────────────────────────────────────────────────────

export function ShippersPage(): React.JSX.Element {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('settings');
  const pageState = useShippersPage();

  const pagination: SimplePagination = {
    currentPage: pageState.currentPage,
    onPageChange: pageState.onPageChange,
    pageSize: pageState.pageSize,
    totalItems: pageState.totalItems,
    totalPages: pageState.totalPages,
  };

  return (
    <div className="flex h-full flex-1 flex-col gap-4">
      <ShippersActionBar
        onBrowseCatalog={pageState.openCatalog}
        onSearchChange={pageState.onSearchChange}
        searchValue={pageState.searchValue}
      />
      <Card className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl shadow-sm">
        <CardContent className="flex min-h-0 flex-1 flex-col p-0">
          <ShippersTable
            configurations={pageState.configurations}
            isLoading={pageState.isLoadingConfigurations}
            pagination={pagination}
          />
        </CardContent>
      </Card>
      <CatalogModal
        emptyMessage={t('shippers.catalog.empty')}
        errorMessage={t('shippers.catalog.error')}
        installLabel={tCommon('actions.install')}
        installedLabel={t('shippers.catalog.installed')}
        isInstalled={(templateId) => pageState.configurations.some((c) => c.templateId === templateId)}
        onClose={pageState.closeCatalog}
        onInstall={pageState.onInstallTemplate}
        open={pageState.isCatalogOpen}
        searchAriaLabel={t('shippers.catalog.searchAriaLabel')}
        searchPlaceholder={t('shippers.catalog.searchPlaceholder')}
        subtitle={t('shippers.catalog.subtitle')}
        title={t('shippers.catalog.title')}
        type={TEMPLATE_TYPE.SHIPPER}
      />
      <InstallShipperDrawer
        onClose={pageState.closeInstallDrawer}
        open={pageState.isInstallDrawerOpen}
        templateId={pageState.pendingInstallTemplateId}
      />
    </div>
  );
}
